import { getCookie } from '../cookie/getCookie';
import { getUserIdFromUA } from './getUserId';

export function getAccount() {
  const account = getCookie('escapename');

  if (!account || account.startsWith('mt_')) {
    // mt_代表游客账户
    return getUserIdFromUA();
  }
  return account;
}